(function () {
  if (window.__SterntalerStockInit) return;
  window.__SterntalerStockInit = true;

  function update(el, variant) {
    if (!variant) { el.style.display = 'none'; return; }

    var managed = variant.inventory_management && variant.inventory_management !== '';
    var qty     = variant.inventory_quantity || 0;

    if (!managed || qty <= 0) {
      el.style.display = 'none';
      el.textContent   = '';
      return;
    }

    el.style.display = '';
    el.classList.toggle('stock-status--ok',  qty > 10);
    el.classList.toggle('stock-status--low', qty > 0 && qty <= 10);
    el.textContent = qty > 10 ? 'Sofort versandfertig' : 'Nur noch ' + qty + ' auf Lager';
  }

  /* Dawn feuert dieses Custom Event nach jedem Varianten-Fetch */
  document.addEventListener('variant:changed', function (e) {
    var variant = e && e.detail && e.detail.variant;
    if (!variant) return;
    document.querySelectorAll('[data-stock-status]').forEach(function (el) {
      update(el, variant);
    });
  });

  /* Shopify PubSub (Dawn intern) – zusätzlicher Hook */
  document.addEventListener('on:variant:change', function (e) {
    var variant = e && e.detail && (e.detail.variant || e.detail.currentVariant);
    if (!variant) return;
    document.querySelectorAll('[data-stock-status]').forEach(function (el) {
      update(el, variant);
    });
  });

  /* Fallback: input[name="id"] change */
  document.addEventListener('change', function (e) {
    var t = e.target;
    if (!t || t.name !== 'id') return;
    var variantId = parseInt(t.value, 10);
    if (!variantId) return;

    /* Varianten-Daten aus dem Liquid-JSON holen falls vorhanden */
    var jsonEl = document.querySelector('[data-product-json]');
    if (!jsonEl) return;
    var product;
    try { product = JSON.parse(jsonEl.textContent); } catch (_) { return; }
    var variant = (product.variants || []).find(function (v) { return v.id === variantId; });
    if (!variant) return;
    document.querySelectorAll('[data-stock-status]').forEach(function (el) {
      update(el, variant);
    });
  });
})();